var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSilver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.52 60.8202C120.52 76.6881 114.217 91.9061 102.996 103.126C91.776 114.347 76.558 120.65 60.6901 120.65C44.824 120.648 29.6085 114.343 18.3904 103.123C7.17225 91.9029 0.87012 76.6864 0.870121 60.8202C0.867493 52.9634 2.41292 45.1829 5.4181 37.9235C8.42328 30.664 12.8293 24.0678 18.3845 18.5117C23.9397 12.9556 30.5352 8.54844 37.7941 5.54204C45.0531 2.53565 52.8332 0.988924 60.6901 0.990238C68.5479 0.98761 76.3291 2.53336 83.5892 5.53917C90.8493 8.54498 97.4459 12.9519 103.002 18.5082C108.558 24.0644 112.965 30.6611 115.971 37.9212C118.977 45.1813 120.523 52.9625 120.52 60.8202V60.8202Z",
    fill: "url(#paint0_linear_2102:3773)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.52 60.8202C111.52 67.4949 110.205 74.1041 107.65 80.2705C105.096 86.4369 101.352 92.0397 96.6315 96.7589C91.9114 101.478 86.3079 105.221 80.1409 107.775C73.974 110.328 67.3645 111.642 60.6899 111.64C54.0166 111.64 47.4086 110.326 41.2434 107.772C35.0782 105.218 29.4765 101.474 24.7583 96.7548C20.04 92.0356 16.2976 86.4332 13.7447 80.2675C11.1918 74.1017 9.87857 67.4935 9.87988 60.8202C9.87857 54.1465 11.1918 47.5378 13.7445 41.3715C16.2972 35.2052 20.0395 29.6021 24.7576 24.8821C29.4758 20.1621 35.0774 16.4177 41.2427 13.8625C47.4079 11.3073 54.0161 9.99155 60.6899 9.99023C74.1708 9.99023 87.0997 15.3455 96.6321 24.878C106.165 34.4105 111.52 47.3393 111.52 60.8202V60.8202Z",
    fill: "url(#paint1_linear_2102:3773)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M105.57 60.8202C105.57 66.7135 104.409 72.549 102.153 77.9935C99.8978 83.4381 96.5918 88.385 92.4242 92.5517C88.2565 96.7183 83.3089 100.023 77.8639 102.278C72.4189 104.532 66.5831 105.692 60.6898 105.69C48.7896 105.69 37.3767 100.963 28.9619 92.5481C20.5472 84.1334 15.8198 72.7205 15.8198 60.8202C15.8304 48.9269 20.5625 37.5243 28.9761 29.1182C37.3897 20.7121 48.7965 15.9902 60.6898 15.9902C72.5849 15.9876 83.9943 20.7083 92.41 29.1147C100.826 37.5211 105.559 48.9252 105.57 60.8202Z",
    fill: "url(#paint2_linear_2102:3773)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M103.78 60.8202C103.777 72.2476 99.2365 83.2062 91.1562 91.2865C83.0758 99.3669 72.1172 103.908 60.6899 103.91C49.2634 103.908 38.3059 99.3666 30.2271 91.2859C22.1483 83.2053 17.6099 72.2467 17.6099 60.8202C17.6099 49.3947 22.1486 38.4371 30.2277 30.3581C38.3068 22.279 49.2643 17.7402 60.6899 17.7402C72.1163 17.7402 83.0749 22.2787 91.1556 30.3575C99.2362 38.4362 103.777 49.3938 103.78 60.8202V60.8202Z",
    fill: "url(#paint3_radial_2102:3773)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7,
    d: "M103.78 60.8202C103.777 72.2476 99.2365 83.2062 91.1562 91.2865C83.0758 99.3669 72.1172 103.908 60.6899 103.91C49.2634 103.908 38.3059 99.3666 30.2271 91.2859C22.1483 83.2053 17.6099 72.2467 17.6099 60.8202C17.6099 49.3947 22.1486 38.4371 30.2277 30.3581C38.3068 22.279 49.2643 17.7402 60.6899 17.7402C72.1163 17.7402 83.0749 22.2787 91.1556 30.3575C99.2362 38.4362 103.777 49.3938 103.78 60.8202V60.8202Z",
    fill: "url(#paint4_radial_2102:3773)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6899 9.99023C54.0161 9.99155 47.4079 11.3073 41.2427 13.8625C35.0774 16.4177 29.4758 20.1621 24.7576 24.8821C20.0395 29.6021 16.2972 35.2052 13.7445 41.3715C11.1918 47.5378 9.87857 54.1465 9.87988 60.8202C9.87857 67.4935 11.1918 74.1017 13.7447 80.2675C16.2976 86.4332 20.04 92.0356 24.7583 96.7548C29.4765 101.474 35.0782 105.218 41.2434 107.772C47.4086 110.326 54.0166 111.64 60.6899 111.64C67.3645 111.642 73.974 110.328 80.1409 107.775C86.3079 105.221 91.9114 101.478 96.6315 96.7589C101.352 92.0397 105.096 86.4369 107.65 80.2705C110.205 74.1041 111.52 67.4949 111.52 60.8202C111.52 47.3393 106.165 34.4105 96.6321 24.878C87.0997 15.3455 74.1708 9.99023 60.6899 9.99023ZM60.6899 110.73C47.4602 110.706 34.7793 105.44 25.4245 96.0857C16.0697 86.7309 10.8037 74.0499 10.7799 60.8202C10.801 47.5889 16.0659 34.9053 25.4209 25.5484C34.776 16.1914 47.4585 10.924 60.6899 10.9002C73.9247 10.9187 86.6123 16.1838 95.9717 25.5413C105.331 34.8988 110.599 47.5854 110.62 60.8202C110.599 74.0551 105.331 86.7416 95.9717 96.0992C86.6123 105.457 73.9247 110.722 60.6899 110.74V110.73Z",
    fill: "url(#paint5_linear_2102:3773)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6898 15.9902C48.7965 15.9902 37.3897 20.7121 28.9761 29.1182C20.5625 37.5243 15.8304 48.9269 15.8198 60.8202C15.8198 72.7205 20.5472 84.1334 28.9619 92.5481C37.3767 100.963 48.7896 105.69 60.6898 105.69C66.5831 105.692 72.4189 104.532 77.8639 102.278C83.3089 100.023 88.2565 96.7183 92.4242 92.5517C96.5918 88.385 99.8978 83.4381 102.153 77.9935C104.409 72.549 105.57 66.7135 105.57 60.8202C105.559 48.9252 100.826 37.5211 92.41 29.1147C83.9943 20.7083 72.5849 15.9876 60.6898 15.9902V15.9902ZM60.6898 104.84C49.0203 104.84 37.8287 100.205 29.5771 91.9529C21.3255 83.7013 16.6898 72.5098 16.6898 60.8402C16.6898 49.1707 21.3255 37.9791 29.5771 29.7275C37.8287 21.4759 49.0203 16.8402 60.6898 16.8402C66.468 16.8402 72.1896 17.9783 77.5279 20.1895C82.8662 22.4007 87.7167 25.6418 91.8025 29.7275C95.8883 33.8133 99.1293 38.6638 101.341 44.0022C103.552 49.3405 104.69 55.0621 104.69 60.8402C104.682 72.5046 100.043 83.6884 91.7919 91.9335C83.5412 100.179 72.3542 104.81 60.6898 104.81V104.84Z",
    fill: "url(#paint6_linear_2102:3773)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6901 0.990238C52.8332 0.988924 45.0531 2.53565 37.7941 5.54204C30.5352 8.54844 23.9397 12.9556 18.3845 18.5117C12.8293 24.0678 8.42328 30.664 5.4181 37.9235C2.41292 45.1829 0.867493 52.9634 0.870121 60.8202C0.87012 76.6864 7.17225 91.9029 18.3904 103.123C29.6085 114.343 44.824 120.648 60.6901 120.65C68.5471 120.65 76.3272 119.103 83.5861 116.096C90.845 113.089 97.4406 108.682 102.996 103.126C108.552 97.5707 112.959 90.9751 115.966 83.7162C118.973 76.4573 120.52 68.6772 120.52 60.8202C120.523 52.9625 118.977 45.1813 115.971 37.9212C112.965 30.6611 108.558 24.0644 103.002 18.5082C97.4459 12.9519 90.8493 8.54498 83.5892 5.53917C76.3291 2.53336 68.5479 0.98761 60.6901 0.990238V0.990238ZM60.6901 119.75C45.0666 119.732 30.0883 113.517 19.0408 102.47C7.99327 91.4221 1.77865 76.4438 1.76012 60.8202C1.776 45.195 7.98946 30.2141 19.0373 19.1644C30.085 8.11477 45.0649 1.89877 60.6901 1.88024C76.3171 1.89612 91.2995 8.11096 102.349 19.1609C113.399 30.2109 119.614 45.1933 119.63 60.8202C119.614 76.4472 113.399 91.4296 102.349 102.48C91.2995 113.53 76.3171 119.744 60.6901 119.76V119.75Z",
    fill: "url(#paint7_linear_2102:3773)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M15.46 35.7903C19.9332 27.7124 26.4863 20.9785 34.4395 16.2871C42.3927 11.5958 51.4562 9.11781 60.69 9.11031C74.3995 9.12619 87.5429 14.5793 97.2369 24.2734C106.931 33.9674 112.384 47.1108 112.4 60.8203C112.399 63.9832 112.111 67.1395 111.54 70.2503L116.26 70.9203L118.03 71.1703C118.629 67.7528 118.93 64.2898 118.93 60.8203C118.931 53.1713 117.426 45.5969 114.5 38.5298C111.573 31.4626 107.284 25.0411 101.875 19.632C96.4672 14.2228 90.0464 9.93198 82.9798 7.00452C75.9131 4.07706 68.339 2.57031 60.69 2.57031C50.4609 2.56836 40.4118 5.26054 31.5537 10.376C22.6956 15.4914 15.341 22.8497 10.23 31.7103C11.91 33.1403 13.66 34.5003 15.46 35.7903Z",
    fill: "url(#paint8_linear_2102:3773)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M101.03 93.1503C96.1863 99.1946 90.0465 104.073 83.0642 107.426C76.0818 110.779 68.4354 112.52 60.6899 112.52C49.5131 112.503 38.6415 108.872 29.6972 102.169C20.7529 95.4671 14.2154 86.0525 11.0599 75.3303C8.57988 74.4403 6.10988 73.5303 3.62988 72.5903C6.34417 85.7185 13.5014 97.5096 23.8953 105.976C34.2891 114.443 47.2841 119.067 60.6899 119.07C70.23 119.071 79.6241 116.728 88.0462 112.246C96.4683 107.765 103.66 101.283 108.99 93.3703C106.34 93.3303 103.68 93.2503 101.03 93.1503Z",
    fill: "url(#paint9_linear_2102:3773)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.03 71.17C127.46 7.99003 42.71 -20.65 10.23 31.71C41.46 -24.96 130.82 7.64003 118.03 71.17Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.03 71.17C127.46 7.99003 42.71 -20.65 10.23 31.71C41.46 -24.96 130.82 7.64003 118.03 71.17Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M109.62 69.0704C117.52 14.5104 46.2902 -10.1996 18.9902 35.0104C45.2102 -13.9096 120.38 14.2304 109.62 69.0704Z",
    fill: "url(#paint10_linear_2102:3773)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.35 67.42C110.26 20.94 47.9498 -0.110003 24.0498 38.42C47.0098 -3.27 112.77 20.7 103.35 67.42Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7801 103.8C71.7801 127.8 38.6101 121.63 16.6201 97.8001C1.99011 81.9101 -2.3799 56.9801 9.01011 33.6001C-22.3499 90.1401 52.8301 148.46 99.7801 103.8Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M93.5299 97.7902C51.5599 133.54 -7.27007 86.4002 16.4599 39.2002C-10.9801 87.4802 52.8399 136.11 93.5299 97.7902Z",
    fill: "url(#paint11_linear_2102:3773)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M91.8802 90.8501C58.3802 123.85 4.66023 85.8501 21.7402 43.8501C1.56023 86.9901 59.6502 125.99 91.8802 90.8501Z",
    fill: "url(#paint12_linear_2102:3773)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2102:3773",
    x1: 19.1901,
    y1: 19.3202,
    x2: 97.6401,
    y2: 97.7702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DADADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2102:3773",
    x1: 8.93988,
    y1: 9.07023,
    x2: 108.09,
    y2: 108.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#DADADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2102:3773",
    x1: 30.9798,
    y1: 26.7302,
    x2: 95.4598,
    y2: 100.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#6E6E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2102:3773",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.0099 31.7002) scale(69.81)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E6E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2102:3773",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.2399 102.03) scale(85.59)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2102:3773",
    x1: 39.8199,
    y1: 14.4702,
    x2: 80.2399,
    y2: 104.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2102:3773",
    x1: 8665.92,
    y1: -11419.9,
    x2: 12289.4,
    y2: -3368.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2102:3773",
    x1: 8774.8,
    y1: -16805.3,
    x2: 18519,
    y2: -3649.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2102:3773",
    x1: 83.17,
    y1: 5.26031,
    x2: 64.55,
    y2: 50.4203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2102:3773",
    x1: 55.8599,
    y1: 94.3803,
    x2: 54.9699,
    y2: 116.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2102:3773",
    x1: 11038.5,
    y1: -5237.88,
    x2: 11834.1,
    y2: -7971.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2102:3773",
    x1: 15835.6,
    y1: -21578.3,
    x2: 13809.9,
    y2: -18869.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2102:3773",
    x1: 9650.98,
    y1: -5198.19,
    x2: 8318.39,
    y2: -3246.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.e73ade0aed223afa9d17ba846facd223.svg";
export { ForwardRef as ReactComponent };